import React from 'react';

import { useJira } from '@atlassian/global-shortcuts/jira';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { InvitedAppShortcuts, type ShortcutItemsConfig } from '@atlassian/cross-join-nudges';

export const GlobalInvitedAppShortcutsWrapper = () => {
	const { cloudId, orgId } = useSessionData();
	const jiraShortcut = useJira('');

	const allowedAppsShortcutItemsConfig: ShortcutItemsConfig = {
		jira: jiraShortcut,
	};

	return (
		<InvitedAppShortcuts
			cloudId={cloudId}
			orgId={orgId}
			shortcutItemsConfig={allowedAppsShortcutItemsConfig}
		/>
	);
};
